// web/src/shell/useCurrentUser.ts
//
// Single source of truth for "who is the current user" across the app shell.
// Wraps meApi.get() in TanStack Query with a key that other code can
// invalidate (e.g., after PATCH /me, after sign out, after account-delete).
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { meApi, type MeResponse } from "../api/me";

export const ME_QUERY_KEY = ["me"] as const;

export function useCurrentUser() {
  return useQuery<MeResponse>({
    queryKey: ME_QUERY_KEY,
    queryFn: () => meApi.get(),
    staleTime: 60_000, // 1 min
  });
}

export function useInvalidateCurrentUser() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ME_QUERY_KEY });
}
